import React from 'react'
// 1. 导入所有 SVG 资源
import User1 from './users-svg/OBJECTS (1).svg'
import User2 from './users-svg/OBJECTS (2).svg'
import User3 from './users-svg/OBJECTS (3).svg'
import User4 from './users-svg/OBJECTS (4).svg'
import User5 from './users-svg/OBJECTS (5).svg'
import User6 from './users-svg/OBJECTS (6).svg'
import User7 from './users-svg/OBJECTS (7).svg'
import User8 from './users-svg/OBJECTS (8).svg'
import User9 from './users-svg/OBJECTS (9).svg'

// 2. 建立数字与组件的映射表
const AVATAR_MAP: Record<number, string> = {
  1: User1,
  2: User2,
  3: User3,
  4: User4,
  5: User5,
  6: User6,
  7: User7,
  8: User8,
  9: User9,
}

interface UserAvatarProps {
  id: string
  size?: number
  className?: string
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  id,
  size = 50,
  className = '',
}) => {
  const currentId = (id.charCodeAt(0) % 9) + 1
  // 获取对应的 SVG 路径，如果 id 不存在则默认显示第 1 个
  const avatarSrc = AVATAR_MAP[currentId]

  return (
    <div
      className={`user-avatar-container ${className}`}
      style={{
        width: size,
        height: size,
        overflow: 'hidden',
        // borderRadius: '50%', // 如果需要圆形头像可以加上
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={avatarSrc}
        alt={`user-avatar-${id}`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'top center', // 强制显示图片顶部，通常是人脸所在位置
        }}
      />
    </div>
  )
}

export default UserAvatar
